import type { AxiosInstance } from 'axios';

import type { TRecommendationRequest, TRecommendationResponse } from '../types';

export type TBatchRecommendationsRequestDto = {
  create: TRecommendationRequest[];
  update: (TRecommendationRequest & { id: string })[];
  delete: string[];
};

export type TBatchRecommendationsResponseDto = {
  created: TRecommendationResponse[];
  updated: TRecommendationResponse[];
  deletedCount: number;
};

export class RecommendationsApi {
  constructor(private readonly agent: AxiosInstance) {}

  fetchList(signal?: AbortSignal): Promise<TRecommendationResponse[]> {
    return this.agent
      .get<TRecommendationResponse[]>('/anomaly-registry/api/v1/recommendations', { signal })
      .then((r) => r.data);
  }

  save(data: TBatchRecommendationsRequestDto, signal?: AbortSignal): Promise<TBatchRecommendationsResponseDto> {
    return this.agent
      .put<TBatchRecommendationsResponseDto>('/anomaly-registry/api/v1/recommendations/batch', data, { signal })
      .then((r) => r.data);
  }
}
